import { useState } from "react";
import { getLastUser, isValidUserId, normalizeUserId, userHomeUrl } from "../../utils/currentUser";
import "./HomePage.css";

/** Shown when the URL names no user: pick a name, land on /user_id=<name>. No password —
 *  the link itself is the account, which is what a demo/testing setup needs. */
export default function SignIn() {
    const [name, setName] = useState("");
    const lastUser = getLastUser();
    const id = normalizeUserId(name);

    const go = (userId) => window.location.assign(userHomeUrl(userId));

    return (
        <div className="pdfu-page">
            <div className="pdfu-card" style={{ maxWidth: 440 }}>
                <div className="pdfu-brand">
                    <div className="pdfu-brand-mark"><i className="bi bi-file-earmark-richtext" /></div>
                    <span className="pdfu-brand-name">AirPDF Workspace</span>
                </div>
                <h1 className="pdfu-title">Who's working today?</h1>
                <p className="pdfu-subtitle">
                    Enter a name to open your workspace. Use the same name next time to get all your files and notes back.
                </p>

                <form className="signin-form" onSubmit={e => { e.preventDefault(); if (isValidUserId(id)) go(id); }}>
                    <input
                        className="signin-input"
                        autoFocus
                        value={name}
                        onChange={e => setName(e.target.value)}
                        placeholder="e.g. testuser"
                        maxLength={64}
                        aria-label="Your name"
                    />
                    <button type="submit" className="pdfu-btn pdfu-btn--primary" disabled={!isValidUserId(id)}>
                        Continue <i className="bi bi-arrow-right" />
                    </button>
                </form>
                {id && id !== name.trim() && (
                    <p className="signin-hint">You'll be signed in as <code>{id}</code></p>
                )}

                {lastUser && (
                    <>
                        <div className="pdfu-divider">or</div>
                        <button className="pdfu-btn signin-continue" onClick={() => go(lastUser)}>
                            <span>Continue as <strong>{lastUser}</strong></span>
                            <i className="bi bi-chevron-right" />
                        </button>
                    </>
                )}

                <p className="signin-hint">
                    Tip: your personal link is <code>{window.location.origin}/user_id={id || "your-name"}</code> — bookmark it.
                </p>
            </div>
        </div>
    );
}
